/*
 * File Created: Thursday, 8th June 2023 3:53:21 pm
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
// import img from "../../assets/images/sst_4_nobg.png";

export function SuggestedProduct(): JSX.Element {
  return (
    <Box
      sx={{
        width: { xs: "47%" },
        backgroundColor: "green",
      }}
    >
      {/* <Box
        sx={{
          width: "100%",
        }}
      > */}
        {/* <Box
          component="img"
          src={img}
          alt="img"
          sx={{
            width: "100%",
            ba
          }}
        /> */}
      {/* </Box> */}
      <Box>
        <Typography>Beige metal hoop tote bag</Typography>
        <Typography>$75.00-$80.00</Typography>
      </Box>
    </Box>
  )
}

function Suggestion(): JSX.Element {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 5,
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: "1.875rem",
          fontWeight: 500,
        }}
      >
        You May Also Like
      </Typography>
    {/* <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        gap: 2,
        flexWrap: "wrap"
        // overflowX: "scroll",
      }}
    >
      {[1, 2, 3, 4, 5].map((data) => {
        return <SuggestedProduct key={data} />
      })}
    </Box> */}
    </Box>
  )
}

export default Suggestion;